import { jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
const SuggestionBubble = (props) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: props.className + " suggestion-bubble",
      onClick: props.onClick,
      children: props.suggestion
    }
  );
};
SuggestionBubble.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  suggestion: PropTypes.string
};
export {
  SuggestionBubble as default
};
//# sourceMappingURL=SuggestionBubble.js.map
